// Copyright (c) Move Closer 2022.

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum DayName {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const dayNamesRegistry: Record<string, string> = {
  1: DayName.Monday,
  2: DayName.Tuesday,
  3: DayName.Wednesday,
  4: DayName.Thursday,
  5: DayName.Friday,
  6: DayName.Saturday,
  7: DayName.Sunday
}
